import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AppStatusState {
  isOnline: boolean;
}

const initialState: AppStatusState = {
  isOnline: true,
};

const appStatusSlice = createSlice({
  name: 'appStatus',
  initialState,
  reducers: {
    setIsOnline: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
    },
  },
});

export const { setIsOnline } = appStatusSlice.actions;

export default appStatusSlice.reducer;
